import { Question, SmartButton } from '@workspace/core-ts/components';
import { useGlobalForm } from '@workspace/core-ts/contexts';
import { SmartFormGlobal, useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { ToutMotards } from '@workspace/core-ts/icons-amo';
import bienvenue from '../content/1-bienvenue';
import type { FormSchemaType } from '@/schema';

export default function Bienvenue() {
    const methods = useSmartFormGlobal<FormSchemaType>();
    const {
        actions: { getContent },
    } = useGlobalForm();

    return (
        <SmartFormGlobal {...methods} className="flex flex-col items-center max-w-2xl mx-auto mt-6 sm:mt-10 mb-20 padding-root">
            <Question.Header>
                <ToutMotards />
                <Question.Title className="text-2xl sm:text-3xl">Bonjour !</Question.Title>
            </Question.Header>

            <Question.Description className="mb-6">{getContent(bienvenue.description)}</Question.Description>

            <p className="font-medium text-secondary text-lg sm:text-xl mb-8">Vous êtes prêt ?</p>
            <SmartButton value="C'est parti !" />
        </SmartFormGlobal>
    );
}
